export default {
  address: state => state.address
};